import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative inline-flex" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      ref: "trigger",
      class: _normalizeClass(["flex h-8 w-8 items-center justify-center rounded-full text-gray-400 hover:text-gray-500", { 'bg-gray-200 text-gray-500': _ctx.dropdownOpen }]),
      "aria-haspopup": "true",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdownOpen && _ctx.toggleDropdownOpen(...args)), ["stop"])),
      "aria-expanded": _ctx.dropdownOpen
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.getCurrentLocale), 1)
    ], 10, _hoisted_2),
    (_ctx.dropdownOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["min-w-16 absolute top-full z-10 mt-1 origin-top-right overflow-hidden rounded bg-white p-1.5 shadow-lg", _ctx.align === 'right' ? 'right-0' : 'left-0'])
        }, [
          _createElementVNode("ul", {
            ref: "dropdown",
            onFocusin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dropdownOpen = true)),
            onFocusout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dropdownOpen = false))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLocales, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: "flex items-center rounded px-1.5 py-1 text-sm font-medium text-gray-600 transition duration-200 ease-in-out hover:bg-gray-100 hover:text-gray-800",
                  onClick: ($event: any) => (_ctx.setCurrentLocale(item.name))
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ], 8, _hoisted_3)
              ]))
            }), 128))
          ], 544)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}